import { Component } from "@angular/core";
import { SharedDataService } from "../../services/shared-data.service";
import { DatePipe } from "@angular/common";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router, RouterModule } from "@angular/router";
import { NormalizeDataService } from "../../services/normalize-data.service";
import { environment } from "../../../environments/environment";
import { take } from "rxjs/operators";
import { createEmbeddingContext, EmbeddingContext } from "amazon-quicksight-embedding-sdk";
import * as QuicksightEmbedding from "amazon-quicksight-embedding-sdk";
import { AuthService } from "../../services/auth.service";

const { quickSightBaseUrl, quickSightDashboards } = environment;

@Component({
    standalone: true,
    selector: "app-conciliations-detail",
    imports: [RouterModule],
    templateUrl: "./conciliations-detail.component.html",
    styleUrl: "./conciliations-detail.component.css"
})
export class ConciliationsDetailV2Component {
  createdAtFrom: string = localStorage.getItem("calendar.created_at_from");
  createdAtTo: string = localStorage.getItem("calendar.created_at_to");
  formattedCreatedAtFrom: string = "";
  formattedcreatedAtTo: string = "";
  quickSightUrl: string;
  embeddingContext: EmbeddingContext;
  dashboard: QuicksightEmbedding.DashboardExperience;

  constructor(public sharedDataService: SharedDataService, private datePipe: DatePipe, private http: HttpClient, private router: Router, public normalizeDataService: NormalizeDataService) {
    this.formattedCreatedAtFrom = this.datePipe.transform(localStorage.getItem("calendar.created_at_from"), "dd-MM-yyyy");
    this.formattedcreatedAtTo = this.datePipe.transform(localStorage.getItem("calendar.created_at_to"), "dd-MM-yyyy");
  }

  ngOnInit(): void {
    this.updateDate();
    // this.setupQuickSightCallbackListener();
    // this.fetchMerchantDetails();

    const hashParams = this.getHashParams();
    const idArchivo = hashParams["p.nombreArchivo"];

    console.log("🧩 ID Archivo desde hash:", idArchivo);

    if (idArchivo) {
      this.GetDashboardURL(idArchivo);
    } else {
      console.warn("⚠️ No se encontró p.idArchivo en el hash URL");
    }
  }

  getHashParams(): Record<string, string> {
    const hash = window.location.hash.substring(1); // Quita el #
    return hash.split("&").reduce((acc, part) => {
      const [key, val] = part.split("=");
      acc[key] = decodeURIComponent(val);
      return acc;
    }, {} as Record<string, string>);
  }

  updateDate() {
    const createdAtFrom = new Date(localStorage.getItem("calendar.created_at_from"));
    const createdAtTo = new Date(localStorage.getItem("calendar.created_at_to"));

    // Suma un día a las fechas
    createdAtFrom.setDate(createdAtFrom.getDate() + 1);
    // createdAtTo.setDate(createdAtTo.getDate() + 1);

    // Formatear las fechas en el formato ('dd-MM-yyyy')
    this.formattedCreatedAtFrom = this.datePipe.transform(createdAtFrom, "dd-MM-yyyy");
    this.formattedcreatedAtTo = this.datePipe.transform(createdAtTo, "dd-MM-yyyy");
  }

  public GetDashboardURL(nombreArchivo: string) {
    // this.quickSightUrl = localStorage.getItem('quickSightUrl');

    const createdAtFrom = this.formattedCreatedAtFrom.substring(6, 10) + "-" + this.formattedCreatedAtFrom.substring(3, 5) + "-" + this.formattedCreatedAtFrom.substring(0, 2);
    const createdAtTo = this.formattedcreatedAtTo.substring(6, 10) + "-" + this.formattedcreatedAtTo.substring(3, 5) + "-" + this.formattedcreatedAtTo.substring(0, 2);
    const merchantId = localStorage.getItem("auth.merchant_id");
    const paramsUrl = `#p.nombreArchivo=${nombreArchivo}`;
    let urlWithParams = "";
    console.log("createdAtFrom", createdAtFrom);
    console.log("createdAtTo", createdAtTo);
    if (this.quickSightUrl == null) {
      const authToken = localStorage.getItem("auth.access_token");
      const httpOptions = {
        headers: new HttpHeaders({
          Accept: "*/*",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        }),
      };

      const dashboardId = quickSightDashboards.conciliations_detail_v2;
      this.http
        .get(`${quickSightBaseUrl}/${dashboardId}`, httpOptions)
        .pipe(take(1))
        .subscribe((data: any) => {
          this.quickSightUrl = data.EmbedUrl;
          //localStorage.setItem('quickSightUrl',this.quickSightUrl);

          console.log("Quicksight:", data.EmbedUrl);
          urlWithParams = data.EmbedUrl + paramsUrl;
          console.log("A-urlWithParams:", urlWithParams);
          this.Dashboard(urlWithParams, merchantId, createdAtFrom, createdAtTo);
        });
    } else {
      this.Dashboard(this.quickSightUrl, merchantId, createdAtFrom, createdAtTo);
    }
  }

  public async Dashboard(embeddedURL: any, merchantId: string, createdAtFrom: string, createdAtTo: string) {
    var containerDiv = document.getElementById("dashboardSalesDetailContainer") || "";
    const host = AuthService.getHost();
    embeddedURL = `${embeddedURL}&p.domain=${host}`
    const frameOptions = {
      url: embeddedURL,
      container: containerDiv,
      height: "771px",
      width: "100%",
      resizeHeightOnSizeChangedEvent: false,
    };
    this.embeddingContext = await createEmbeddingContext();
    if (this.dashboard == null) {
      this.dashboard = await this.embeddingContext.embedDashboard(frameOptions);
      console.log("Dashboard", this.dashboard);
    } else {
      this.dashboard.setParameters([
        {
          Name: "merchantId",
          Values: [merchantId],
        },
        {
          Name: "createdAtFrom",
          Values: [createdAtFrom],
        },
        {
          Name: "createdAtTo",
          Values: [createdAtTo],
        },
        {
          Name: 'domain',
          Values: [host]
        }
      ]);
    }
  }
}
